// Curated everyday-task icons (lucide-react names in PascalCase).
// Used by IconPicker and NoteTile. Grouped into categories so the picker
// can show them by domain. All names are validated against lucide-react.
export const ICON_CATEGORIES = [
  {
    label: "Shopping",
    icons: [
      { name: "ShoppingCart", label: "Cart" },
      { name: "ShoppingBag", label: "Bag" },
      { name: "ClipboardList", label: "List" },
      { name: "Gift", label: "Gift" },
      { name: "Package", label: "Package" },
      { name: "PackageOpen", label: "Unbox" },
      { name: "Tag", label: "Tag" },
      { name: "Store", label: "Store" },
      { name: "Truck", label: "Delivery" },
      { name: "Boxes", label: "Boxes" },
      { name: "Barcode", label: "Barcode" },
      { name: "Warehouse", label: "Warehouse" },
      { name: "Percent", label: "Sale" },
      { name: "Ticket", label: "Ticket" },
    ],
  },
  {
    label: "Health & Fitness",
    icons: [
      { name: "Pill", label: "Pill" },
      { name: "Tablets", label: "Tablets" },
      { name: "Dumbbell", label: "Gym" },
      { name: "Heart", label: "Heart" },
      { name: "HeartPulse", label: "Pulse" },
      { name: "Activity", label: "Activity" },
      { name: "Stethoscope", label: "Doctor" },
      { name: "Bike", label: "Bike" },
      { name: "Moon", label: "Sleep" },
      { name: "BedDouble", label: "Bedtime" },
      { name: "Droplet", label: "Hydrate" },
      { name: "Weight", label: "Weight" },
      { name: "Bandage", label: "Bandage" },
      { name: "Syringe", label: "Shot" },
      { name: "Ambulance", label: "Emergency" },
      { name: "Hospital", label: "Hospital" },
      { name: "Cross", label: "Medical" },
    ],
  },
  {
    label: "Family & Kids",
    icons: [
      { name: "Baby", label: "Baby" },
      { name: "Users", label: "Family" },
      { name: "PersonStanding", label: "Person" },
      { name: "HeartHandshake", label: "Care" },
      { name: "Rainbow", label: "Rainbow" },
      { name: "Puzzle", label: "Puzzle" },
      { name: "Blocks", label: "Blocks" },
      { name: "PawPrint", label: "Paw" },
      { name: "Trophy", label: "Reward" },
    ],
  },
  {
    label: "Pets & Animals",
    icons: [
      { name: "Cat", label: "Cat" },
      { name: "Dog", label: "Dog" },
      { name: "Bird", label: "Bird" },
      { name: "Fish", label: "Fish" },
      { name: "Rabbit", label: "Rabbit" },
      { name: "Turtle", label: "Turtle" },
      { name: "Squirrel", label: "Squirrel" },
      { name: "Rat", label: "Small pet" },
      { name: "Snail", label: "Snail" },
      { name: "Bug", label: "Bug" },
      { name: "PawPrint", label: "Vet" },
      { name: "Bone", label: "Bone" },
    ],
  },
  {
    label: "Home",
    icons: [
      { name: "Home", label: "Home" },
      { name: "Building", label: "Building" },
      { name: "Building2", label: "Apt" },
      { name: "Sofa", label: "Sofa" },
      { name: "Armchair", label: "Chair" },
      { name: "Bed", label: "Bed" },
      { name: "Bath", label: "Bath" },
      { name: "Toilet", label: "Toilet" },
      { name: "Refrigerator", label: "Fridge" },
      { name: "Microwave", label: "Microwave" },
      { name: "WashingMachine", label: "Laundry" },
      { name: "Lamp", label: "Lamp" },
      { name: "LampCeiling", label: "Light" },
      { name: "Lightbulb", label: "Idea" },
      { name: "Plug", label: "Outlet" },
      { name: "Fan", label: "Fan" },
      { name: "DoorOpen", label: "Door" },
      { name: "KeyRound", label: "Keys" },
      { name: "Wrench", label: "Repair" },
      { name: "Trash2", label: "Chores" },
      { name: "Sparkles", label: "Clean" },
      { name: "Flower2", label: "Garden" },
      { name: "Fence", label: "Yard" },
    ],
  },
  {
    label: "Work",
    icons: [
      { name: "Briefcase", label: "Work" },
      { name: "Laptop", label: "Laptop" },
      { name: "Calendar", label: "Calendar" },
      { name: "FileText", label: "Docs" },
      { name: "Users", label: "Team" },
      { name: "Handshake", label: "Deal" },
      { name: "Target", label: "Goal" },
      { name: "Presentation", label: "Meeting" },
      { name: "PenTool", label: "Design" },
      { name: "ClipboardCheck", label: "Approve" },
      { name: "MailOpen", label: "Email" },
      { name: "Printer", label: "Print" },
      { name: "Inbox", label: "Inbox" },
      { name: "Archive", label: "Archive" },
      { name: "FolderOpen", label: "Folder" },
      { name: "PieChart", label: "Report" },
      { name: "LineChart", label: "Chart" },
      { name: "BarChart", label: "Stats" },
      { name: "Rocket", label: "Launch" },
      { name: "Zap", label: "Power" },
      { name: "Award", label: "Award" },
      { name: "Trophy", label: "Trophy" },
      { name: "Layers", label: "Layers" },
    ],
  },
  {
    label: "Food & Drink",
    icons: [
      { name: "Coffee", label: "Coffee" },
      { name: "Utensils", label: "Meal" },
      { name: "UtensilsCrossed", label: "Dine" },
      { name: "ChefHat", label: "Cook" },
      { name: "Apple", label: "Fruit" },
      { name: "Cherry", label: "Cherry" },
      { name: "Grape", label: "Grape" },
      { name: "Salad", label: "Salad" },
      { name: "Sandwich", label: "Sandwich" },
      { name: "Pizza", label: "Pizza" },
      { name: "Soup", label: "Soup" },
      { name: "Croissant", label: "Bakery" },
      { name: "Cake", label: "Cake" },
      { name: "Cookie", label: "Cookie" },
      { name: "IceCream", label: "Ice Cream" },
      { name: "Popcorn", label: "Popcorn" },
      { name: "Lollipop", label: "Candy" },
      { name: "Beef", label: "Meat" },
      { name: "Fish", label: "Seafood" },
      { name: "Egg", label: "Egg" },
      { name: "Milk", label: "Milk" },
      { name: "Carrot", label: "Veggies" },
      { name: "Wheat", label: "Grain" },
      { name: "Nut", label: "Nuts" },
      { name: "Wine", label: "Wine" },
      { name: "Beer", label: "Beer" },
      { name: "Martini", label: "Cocktail" },
      { name: "GlassWater", label: "Water" },
    ],
  },
  {
    label: "Travel",
    icons: [
      { name: "Plane", label: "Flight" },
      { name: "PlaneTakeoff", label: "Depart" },
      { name: "PlaneLanding", label: "Arrive" },
      { name: "Car", label: "Drive" },
      { name: "Bus", label: "Bus" },
      { name: "Train", label: "Train" },
      { name: "Ship", label: "Ship" },
      { name: "Sailboat", label: "Sail" },
      { name: "MapPin", label: "Place" },
      { name: "Map", label: "Map" },
      { name: "Navigation", label: "Nav" },
      { name: "Globe", label: "World" },
      { name: "Luggage", label: "Trip" },
      { name: "Backpack", label: "Backpack" },
      { name: "Compass", label: "Explore" },
      { name: "Camera", label: "Photo" },
      { name: "Tent", label: "Camp" },
      { name: "TentTree", label: "Outdoors" },
      { name: "Hotel", label: "Hotel" },
      { name: "Mountain", label: "Mountain" },
      { name: "TreePalm", label: "Beach" },
      { name: "Umbrella", label: "Umbrella" },
      { name: "Anchor", label: "Anchor" },
    ],
  },
  {
    label: "Vehicles",
    icons: [
      { name: "Car", label: "Car" },
      { name: "CarFront", label: "Car" },
      { name: "Truck", label: "Truck" },
      { name: "Bus", label: "Bus" },
      { name: "BusFront", label: "Bus" },
      { name: "Bike", label: "Bike" },
      { name: "Train", label: "Train" },
      { name: "TrainFront", label: "Train" },
      { name: "Plane", label: "Plane" },
      { name: "Ship", label: "Ship" },
      { name: "Sailboat", label: "Boat" },
      { name: "Rocket", label: "Rocket" },
      { name: "Ambulance", label: "Ambulance" },
      { name: "Fuel", label: "Fuel" },
      { name: "ParkingCircle", label: "Parking" },
    ],
  },
  {
    label: "Money",
    icons: [
      { name: "Wallet", label: "Wallet" },
      { name: "CreditCard", label: "Card" },
      { name: "PiggyBank", label: "Save" },
      { name: "DollarSign", label: "USD" },
      { name: "Euro", label: "EUR" },
      { name: "Bitcoin", label: "Crypto" },
      { name: "TrendingUp", label: "Invest" },
      { name: "Receipt", label: "Bills" },
      { name: "Banknote", label: "Cash" },
      { name: "Coins", label: "Coins" },
      { name: "Landmark", label: "Bank" },
      { name: "Calculator", label: "Calc" },
      { name: "HandCoins", label: "Payout" },
      { name: "BadgeDollarSign", label: "Deal" },
      { name: "ArrowRightLeft", label: "Swap" },
    ],
  },
  {
    label: "Education",
    icons: [
      { name: "GraduationCap", label: "School" },
      { name: "School", label: "Campus" },
      { name: "Library", label: "Library" },
      { name: "BookOpen", label: "Open Book" },
      { name: "Book", label: "Book" },
      { name: "BookMarked", label: "Bookmark" },
      { name: "BookCheck", label: "Study" },
      { name: "Notebook", label: "Notebook" },
      { name: "Pencil", label: "Pencil" },
      { name: "PenLine", label: "Write" },
      { name: "Ruler", label: "Ruler" },
      { name: "Calculator", label: "Math" },
      { name: "FlaskConical", label: "Chem" },
      { name: "Beaker", label: "Lab" },
      { name: "Atom", label: "Science" },
      { name: "Microscope", label: "Micro" },
      { name: "Backpack", label: "Backpack" },
    ],
  },
  {
    label: "Tech",
    icons: [
      { name: "Laptop", label: "Laptop" },
      { name: "Smartphone", label: "Phone" },
      { name: "Tablet", label: "Tablet" },
      { name: "Monitor", label: "Monitor" },
      { name: "Watch", label: "Watch" },
      { name: "Tv", label: "TV" },
      { name: "Camera", label: "Camera" },
      { name: "Headphones", label: "Headphones" },
      { name: "Speaker", label: "Speaker" },
      { name: "Radio", label: "Radio" },
      { name: "Router", label: "Router" },
      { name: "Wifi", label: "Wi-Fi" },
      { name: "Bluetooth", label: "BT" },
      { name: "Battery", label: "Battery" },
      { name: "HardDrive", label: "Drive" },
      { name: "Cpu", label: "CPU" },
      { name: "Keyboard", label: "Keys" },
      { name: "Mouse", label: "Mouse" },
      { name: "Server", label: "Server" },
      { name: "Cloud", label: "Cloud" },
      { name: "CloudUpload", label: "Upload" },
      { name: "CloudDownload", label: "Download" },
      { name: "Usb", label: "USB" },
      { name: "Cable", label: "Cable" },
    ],
  },
  {
    label: "Communication",
    icons: [
      { name: "Mail", label: "Mail" },
      { name: "MailOpen", label: "Read" },
      { name: "Send", label: "Send" },
      { name: "Inbox", label: "Inbox" },
      { name: "Phone", label: "Phone" },
      { name: "PhoneCall", label: "Call" },
      { name: "PhoneOutgoing", label: "Dial" },
      { name: "PhoneIncoming", label: "Incoming" },
      { name: "Voicemail", label: "Voicemail" },
      { name: "MessageCircle", label: "Chat" },
      { name: "MessageSquare", label: "Message" },
      { name: "Video", label: "Video" },
      { name: "Mic", label: "Mic" },
      { name: "MicOff", label: "Mute" },
      { name: "Volume2", label: "Volume" },
      { name: "Bell", label: "Bell" },
      { name: "AtSign", label: "Mention" },
      { name: "Hash", label: "Tag" },
      { name: "Rss", label: "Feed" },
    ],
  },
  {
    label: "Weather & Nature",
    icons: [
      { name: "Sun", label: "Sun" },
      { name: "Moon", label: "Moon" },
      { name: "Cloud", label: "Cloud" },
      { name: "CloudRain", label: "Rain" },
      { name: "CloudSnow", label: "Snow" },
      { name: "CloudLightning", label: "Storm" },
      { name: "CloudDrizzle", label: "Drizzle" },
      { name: "Wind", label: "Wind" },
      { name: "Rainbow", label: "Rainbow" },
      { name: "Snowflake", label: "Cold" },
      { name: "Sunrise", label: "Sunrise" },
      { name: "Sunset", label: "Sunset" },
      { name: "Thermometer", label: "Temp" },
      { name: "Waves", label: "Water" },
      { name: "Droplet", label: "Drop" },
      { name: "TreeDeciduous", label: "Tree" },
      { name: "TreePine", label: "Pine" },
      { name: "TreePalm", label: "Palm" },
      { name: "Trees", label: "Forest" },
      { name: "Flower2", label: "Flower" },
      { name: "Sprout", label: "Plant" },
      { name: "Leaf", label: "Leaf" },
      { name: "Mountain", label: "Mountain" },
    ],
  },
  {
    label: "Music & Media",
    icons: [
      { name: "Music", label: "Music" },
      { name: "Music2", label: "Note" },
      { name: "Music4", label: "Notes" },
      { name: "Headphones", label: "Listen" },
      { name: "Radio", label: "Radio" },
      { name: "Guitar", label: "Guitar" },
      { name: "Piano", label: "Piano" },
      { name: "Drum", label: "Drums" },
      { name: "Mic", label: "Mic" },
      { name: "Podcast", label: "Podcast" },
      { name: "Disc", label: "Disc" },
      { name: "Disc3", label: "Vinyl" },
      { name: "ListMusic", label: "Playlist" },
      { name: "Film", label: "Film" },
      { name: "Video", label: "Video" },
      { name: "Play", label: "Play" },
      { name: "Pause", label: "Pause" },
      { name: "SkipForward", label: "Skip" },
      { name: "SkipBack", label: "Back" },
      { name: "Tv", label: "TV" },
      { name: "Popcorn", label: "Movie" },
    ],
  },
  {
    label: "Sports",
    icons: [
      { name: "Trophy", label: "Trophy" },
      { name: "Medal", label: "Medal" },
      { name: "Award", label: "Award" },
      { name: "Target", label: "Target" },
      { name: "Volleyball", label: "Ball" },
      { name: "Dumbbell", label: "Weights" },
      { name: "Bike", label: "Cycling" },
      { name: "Activity", label: "Cardio" },
      { name: "PersonStanding", label: "Runner" },
      { name: "Flag", label: "Finish" },
      { name: "Timer", label: "Timer" },
      { name: "Waves", label: "Swim" },
      { name: "Snowflake", label: "Ski" },
      { name: "Mountain", label: "Climb" },
      { name: "Tent", label: "Camp" },
    ],
  },
  {
    label: "Arts & Crafts",
    icons: [
      { name: "Palette", label: "Palette" },
      { name: "Paintbrush", label: "Paint" },
      { name: "Brush", label: "Brush" },
      { name: "PenTool", label: "Draw" },
      { name: "Pencil", label: "Pencil" },
      { name: "Scissors", label: "Scissors" },
      { name: "SprayCan", label: "Spray" },
      { name: "Pipette", label: "Dropper" },
      { name: "Feather", label: "Feather" },
      { name: "Sticker", label: "Sticker" },
      { name: "Ruler", label: "Ruler" },
      { name: "Sparkles", label: "Sparkle" },
    ],
  },
  {
    label: "Style & Beauty",
    icons: [
      { name: "Shirt", label: "Shirt" },
      { name: "Watch", label: "Watch" },
      { name: "Glasses", label: "Glasses" },
      { name: "Gem", label: "Gem" },
      { name: "Diamond", label: "Diamond" },
      { name: "Crown", label: "Crown" },
      { name: "Sparkles", label: "Glam" },
      { name: "Palette", label: "Makeup" },
      { name: "Scissors", label: "Salon" },
      { name: "Bath", label: "Spa" },
    ],
  },
  {
    label: "Mood",
    icons: [
      { name: "Smile", label: "Happy" },
      { name: "Laugh", label: "Laugh" },
      { name: "Meh", label: "Meh" },
      { name: "Frown", label: "Sad" },
      { name: "Angry", label: "Angry" },
      { name: "Annoyed", label: "Annoyed" },
      { name: "Heart", label: "Love" },
      { name: "HeartCrack", label: "Broken" },
      { name: "ThumbsUp", label: "Like" },
      { name: "ThumbsDown", label: "Dislike" },
      { name: "HandHelping", label: "Help" },
      { name: "PartyPopper", label: "Party" },
    ],
  },
  {
    label: "Time & Planning",
    icons: [
      { name: "Calendar", label: "Calendar" },
      { name: "CalendarCheck", label: "Done" },
      { name: "CalendarClock", label: "Schedule" },
      { name: "CalendarDays", label: "Days" },
      { name: "CalendarPlus", label: "New" },
      { name: "Clock", label: "Clock" },
      { name: "Clock1", label: "1 AM" },
      { name: "Clock12", label: "Noon" },
      { name: "Timer", label: "Timer" },
      { name: "Hourglass", label: "Hourglass" },
      { name: "AlarmClock", label: "Alarm" },
      { name: "AlarmClockCheck", label: "Done" },
      { name: "AlarmClockOff", label: "Snooze" },
      { name: "Watch", label: "Watch" },
    ],
  },
  {
    label: "Files & Docs",
    icons: [
      { name: "FileText", label: "Doc" },
      { name: "File", label: "File" },
      { name: "FileImage", label: "Image" },
      { name: "FileVideo", label: "Video" },
      { name: "FileAudio", label: "Audio" },
      { name: "FilePlus", label: "New" },
      { name: "FileCode", label: "Code" },
      { name: "FileSpreadsheet", label: "Sheet" },
      { name: "Folder", label: "Folder" },
      { name: "FolderOpen", label: "Open" },
      { name: "Files", label: "Files" },
      { name: "ClipboardList", label: "List" },
      { name: "ClipboardCheck", label: "Check" },
      { name: "Archive", label: "Archive" },
      { name: "Inbox", label: "Inbox" },
      { name: "Paperclip", label: "Attach" },
      { name: "Bookmark", label: "Bookmark" },
    ],
  },
  {
    label: "Personal",
    icons: [
      { name: "Book", label: "Read" },
      { name: "Star", label: "Star" },
      { name: "Bell", label: "Reminder" },
      { name: "Music", label: "Music" },
      { name: "Gamepad2", label: "Play" },
      { name: "GraduationCap", label: "Study" },
      { name: "Cat", label: "Pet" },
      { name: "PartyPopper", label: "Party" },
      { name: "User", label: "Me" },
      { name: "Sun", label: "Sun" },
      { name: "Bookmark", label: "Bookmark" },
    ],
  },
  {
    label: "Symbols",
    icons: [
      { name: "Star", label: "Star" },
      { name: "Heart", label: "Heart" },
      { name: "Circle", label: "Circle" },
      { name: "Square", label: "Square" },
      { name: "Triangle", label: "Triangle" },
      { name: "Diamond", label: "Diamond" },
      { name: "Hexagon", label: "Hexagon" },
      { name: "Octagon", label: "Octagon" },
      { name: "Pentagon", label: "Pentagon" },
      { name: "Shield", label: "Shield" },
      { name: "Crown", label: "Crown" },
      { name: "Zap", label: "Bolt" },
      { name: "Flame", label: "Fire" },
      { name: "Sparkle", label: "Spark" },
      { name: "Sparkles", label: "Sparkles" },
      { name: "Award", label: "Award" },
      { name: "Sword", label: "Sword" },
    ],
  },
];

// Curated background presets — solid colors + gradients
// Expanded palette covering vibrant, pastel, earthy, and moody tones so users
// can pick from a wide random spectrum for their tile backgrounds.
export const BACKGROUND_COLORS = [
  // --- Original 12 (kept for backwards compatibility) ---
  { name: "Slate",         value: "#334155" },
  { name: "Rose",          value: "#e11d48" },
  { name: "Orange",        value: "#ea580c" },
  { name: "Amber",         value: "#d97706" },
  { name: "Emerald",       value: "#059669" },
  { name: "Teal",          value: "#0d9488" },
  { name: "Sky",           value: "#0284c7" },
  { name: "Indigo",        value: "#4f46e5" },
  { name: "Violet",        value: "#7c3aed" },
  { name: "Fuchsia",       value: "#c026d3" },
  { name: "Charcoal",      value: "#1c1917" },
  { name: "Bone",          value: "#f5f5f4" },

  // --- +30 varied colors (neon, vibrant, pastel, earthy, moody) ---
  // Vibrant / neon
  { name: "Neon Pink",     value: "#ff006e" },
  { name: "Electric Blue", value: "#3a86ff" },
  { name: "Chartreuse",    value: "#ccff00" },
  { name: "Magenta",       value: "#ff00ff" },
  { name: "Cyan Pop",      value: "#00e5ff" },
  { name: "Vivid Yellow",  value: "#ffd60a" },
  { name: "Deep Purple",   value: "#4a148c" },
  { name: "Blood Red",     value: "#8b0000" },
  { name: "Hot Coral",     value: "#ff5a5f" },
  { name: "Neon Green",    value: "#39ff14" },

  // Pastel / soft
  { name: "Baby Blue",     value: "#a2d2ff" },
  { name: "Blush",         value: "#ffb3ba" },
  { name: "Butter",        value: "#fff2a8" },
  { name: "Sage",          value: "#b8d8be" },
  { name: "Lilac",         value: "#c7b8ea" },
  { name: "Peach Cream",   value: "#ffdab9" },
  { name: "Powder",        value: "#cfe8ff" },
  { name: "Mint Cream",    value: "#c7f9cc" },
  { name: "Cotton Candy",  value: "#ffbcd9" },
  { name: "Seafoam",       value: "#9be3c0" },

  // Earthy / muted
  { name: "Rust",          value: "#b7410e" },
  { name: "Olive",         value: "#556b2f" },
  { name: "Terracotta",    value: "#cc6b49" },
  { name: "Mustard",       value: "#d4a017" },
  { name: "Sand",          value: "#d2b48c" },
  { name: "Mocha",         value: "#6f4e37" },
  { name: "Wine",          value: "#722f37" },
  { name: "Copper",        value: "#b87333" },

  // Moody / deep
  { name: "Midnight",      value: "#191970" },
  { name: "Ink",           value: "#0d1b2a" },
  { name: "Espresso",      value: "#3e2723" },
];

export const BACKGROUND_GRADIENTS = [
  // --- Original 10 (kept for backwards compatibility) ---
  { name: "Sunset",         value: "linear-gradient(135deg, #f97316 0%, #db2777 100%)" },
  { name: "Ocean",          value: "linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%)" },
  { name: "Forest",         value: "linear-gradient(135deg, #10b981 0%, #064e3b 100%)" },
  { name: "Aurora",         value: "linear-gradient(135deg, #8b5cf6 0%, #06b6d4 100%)" },
  { name: "Peach",          value: "linear-gradient(135deg, #fde68a 0%, #fb7185 100%)" },
  { name: "Nightfall",      value: "linear-gradient(135deg, #1e293b 0%, #7c3aed 100%)" },
  { name: "Ember",          value: "linear-gradient(135deg, #7f1d1d 0%, #f59e0b 100%)" },
  { name: "Mint",           value: "linear-gradient(135deg, #86efac 0%, #059669 100%)" },
  { name: "Rose Gold",      value: "linear-gradient(135deg, #fbcfe8 0%, #be123c 100%)" },
  { name: "Cosmic",          value: "linear-gradient(135deg, #0f172a 0%, #ec4899 100%)" },

  // --- +20 richer gradients ---
  { name: "Golden Hour",    value: "linear-gradient(135deg, #ff9a56 0%, #ff5e62 100%)" },
  { name: "Cotton Candy",   value: "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)" },
  { name: "Deep Sea",       value: "linear-gradient(135deg, #2b32b2 0%, #1488cc 100%)" },
  { name: "Mango Tango",    value: "linear-gradient(135deg, #ffa751 0%, #ffe259 100%)" },
  { name: "Blueberry",      value: "linear-gradient(135deg, #4568dc 0%, #b06ab3 100%)" },
  { name: "Cherry Blossom", value: "linear-gradient(135deg, #f78ca0 0%, #f9748f 100%)" },
  { name: "Northern Lights", value: "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)" },
  { name: "Purple Rain",    value: "linear-gradient(135deg, #4facfe 0%, #9333ea 100%)" },
  { name: "Firestorm",      value: "linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)" },
  { name: "Emerald Dream",  value: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)" },
  { name: "Twilight Sky",   value: "linear-gradient(135deg, #141e30 0%, #243b55 100%)" },
  { name: "Neon Grid",      value: "linear-gradient(135deg, #ff00cc 0%, #333399 100%)" },
  { name: "Autumn Leaves",  value: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)" },
  { name: "Berry Wine",     value: "linear-gradient(135deg, #654ea3 0%, #eaafc8 100%)" },
  { name: "Tropic",         value: "linear-gradient(135deg, #00c9ff 0%, #92fe9d 100%)" },
  { name: "Lavender Dust",  value: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)" },
  { name: "Volcanic",       value: "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)" },
  { name: "Deep Space",     value: "linear-gradient(135deg, #000428 0%, #004e92 100%)" },
  { name: "Rainforest",     value: "linear-gradient(135deg, #134e5e 0%, #71b280 100%)" },
  { name: "Watermelon",     value: "linear-gradient(135deg, #ff6b6b 0%, #ffe66d 100%)" },
];

// Default background when none set (dark, subtle)
export const DEFAULT_BACKGROUND = {
  type: "gradient",
  value: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
};

// Flatten icons for name-lookup
export const ALL_ICONS = ICON_CATEGORIES.flatMap(c => c.icons);
